import React, { useEffect, useRef, useState } from "react";
import { Menu, MenuItem } from "../Menu";
import Checkbox from "../Checkbox";
import Chip from "../Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const QueueSelect = ({ selectedQueueIds, onChange }) => {
	const [queues, setQueues] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const buttonRef = useRef(null);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/queue");
				setQueues(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleToggleQueue = queueId => {
		const isSelected = selectedQueueIds.indexOf(queueId) > -1;
		const newSelectedQueueIds = isSelected
			? selectedQueueIds.filter(id => id !== queueId)
			: [...selectedQueueIds, queueId];
		onChange(newSelectedQueueIds);
	};

	return (
		<div style={{ marginTop: 6 }} className="relative w-full">
			<label className="absolute -top-2 left-2 z-[1] bg-farmazon-surface px-1 text-[11px] leading-4 text-farmazon-text-muted">
				{i18n.t("queueSelect.inputLabel")}
			</label>
			<button
				type="button"
				ref={buttonRef}
				onClick={() => setAnchorEl(buttonRef.current)}
				className="flex min-h-[42px] w-full flex-wrap items-center gap-1 rounded-lg border border-solid border-[var(--farmazon-input-border)] bg-[var(--farmazon-input)] px-3 py-1.5 text-left text-sm text-farmazon-text outline-none transition-colors hover:border-slate-400"
			>
				{selectedQueueIds?.length > 0 &&
					selectedQueueIds.map(id => {
						const queue = queues.find(q => q.id === id);
						return queue ? (
							<Chip
								key={id}
								label={queue.name}
								variant="outlined"
								style={{ backgroundColor: queue.color }}
								className="m-0.5"
							/>
						) : null;
					})}
			</button>
			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
				{queues.map(queue => (
					<MenuItem key={queue.id} onClick={() => handleToggleQueue(queue.id)}>
						<Checkbox checked={selectedQueueIds.indexOf(queue.id) > -1} onChange={() => {}} />
						{queue.name}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};

export default QueueSelect;
